import {ReactElement} from "react";
import {HOTData, PendingUpdates} from "./logic";
import Handsontable from "handsontable";
import {Button} from "@zendeskgarden/react-buttons";
import {ReactComponent as MaximizeIcon} from '@zendeskgarden/svg-icons/src/16/maximize-stroke.svg';
import {ReactComponent as MinimizeIcon} from '@zendeskgarden/svg-icons/src/16/minimize-stroke.svg';
import {ReactComponent as ChevronRightIcon} from '@zendeskgarden/svg-icons/src/16/chevron-right-stroke.svg';
import {ReactComponent as ChevronDownIcon} from '@zendeskgarden/svg-icons/src/16/chevron-down-stroke.svg';
import * as css from "./unitTypeSyncWithPMSTable.module.scss";

export type ICellRenderer = {
    valuesStartFromIndex: number,
    rowNumToUnitTypeId: HOTData["rowNumToUnitTypeId"],
    pendingUpdates: PendingUpdates | undefined,
    isEditing: boolean,
    allRowsExpanded: boolean,
    hiddenRows: number[],
    handleRowToggleClick: (row: number) => void,
    [key: string]: any,
};

export function CellRenderer(customProps: ICellRenderer, ..._: any): ReactElement {
    const {instance, TD, row, col, prop, value, cellProperties, rowNumToUnitTypeId,
        pendingUpdates, valuesStartFromIndex, isEditing,
        allRowsExpanded, hiddenRows, handleRowToggleClick, handleAllRowsToggleClick
    } = customProps as ICellRenderer & {
        TD: HTMLTableCellElement;
        cellProperties: Handsontable.CellProperties;
    };
    const unitTypeId = rowNumToUnitTypeId[row];
    function setupStyling() {
        const classNames = [];
        TD.className = "";
        if(!unitTypeId || col == 0) {
            cellProperties.readOnly = true;
        }
        if(col - 1 == valuesStartFromIndex && valuesStartFromIndex > 0) {
            classNames.push(css.forecastedSplit);
        }
        if(unitTypeId) {
            classNames.push(css.unitTypeRowCell); // visual split between unit type rows group
            if(col - 1 >= valuesStartFromIndex) {
                classNames.push(css.forecastedCell);
            }
            const utPending = pendingUpdates?.unitTypeUpdates.get(unitTypeId);
            // hightlight modified cells
            const pendingValue = utPending?.[col - 1];
            if(pendingValue !== undefined) {
                classNames.push(css.modified);
            }
            if(col - 1 >= 0 && col - 1 < 12 && !isEditing) {
                classNames.push(css.readonlyEditableCell);
            }
        }
        if(classNames.length > 0) {
            if(TD.className) {
                classNames.push(TD.className);
            }
            TD.className = classNames.join(" ");
        }
    }
    setupStyling();

    if(row == 0 && col == 0) {
        return (
            <div className={css.descriptionHeaderCell}>
                <span>{value}</span>
                <Button onClick={handleAllRowsToggleClick} size="small" isBasic>
                    {allRowsExpanded ?
                        <MinimizeIcon /> : <MaximizeIcon />
                    }
                </Button>
            </div>
        );
    }
    if(row > 0 && col == 0 && unitTypeId) {
        return (
            <div className={css.descriptionHeaderCell}>
                <span>{value}</span>
                <Button
                    onClick={() => handleRowToggleClick(row)}
                    style={{minWidth: "40px"}}
                    size="small" isBasic
                >
                    {hiddenRows.includes(row + 1) ? <ChevronRightIcon /> : <ChevronDownIcon />}
                </Button>
            </div>
        );
    }
    if(row == 0 && col > 0) {
        return <div className={css.monthHeaderCell} dangerouslySetInnerHTML={{__html: value}} />;
    }
    return value;
}